import es from './es'
import en from './en'

export default {
  "en": {"name": "English", "englishName": "English", values:en},
  "es": {"name": "Español", "englishName": "Spanish", values:es}
}
